import * as Sentry from '@sentry/astro'
import Core from '@/services/shopify/lib/core'
import { createCartMethods } from '@/services/shopify/lib/extend/entities/cart'
import { createDiscountMethods } from '@/services/shopify/lib/extend/entities/discount'
import { extendInventoryMethods } from '@/services/shopify/lib/extend/entities/inventory'

const { buildBaseShopifyPlugin } = Core

const buildShopifyPlugin = (
  client,
  graphQLClient,
  options,
  { vuex, cookies, sentry },
) => {
  const baseShopifyPlugin = buildBaseShopifyPlugin(
    client,
    graphQLClient,
    options,
    { vuex, cookies, sentry },
  )

  const $store = vuex

  const getCart = () => $store.getters['store/getCart']
  const getCartID = () => $store.getters['store/getCartID']
  const setLocalCart = (newCart) => $store.dispatch('store/setCart', newCart)
  const clearLocalCart = () => $store.dispatch('store/clearCart')

  const query = async (queryType = 'NUXT_SHOPIFY', query, variables = {}) => {
    try {
      const response = await graphQLClient({ query, variables })

      const { data, errors } = response

      if (errors) throw new Error(`${queryType}: ${JSON.stringify(errors)}`)

      if (!data) throw new Error('No data found')

      return data
    } catch (error) {
      console.log(error)
      Sentry.captureException(error)
    }
  }

  const extendedShopifyPlugin = {
    checkout: createCartMethods({
      query,
      options,
      cookies,
      getCart,
      setLocalCart,
      clearLocalCart,
      getCartID,
    }),
    discount: createDiscountMethods({
      query,
      setLocalCart,
      getCartID,
    }),
    inventory: extendInventoryMethods(baseShopifyPlugin.inventory),
  }

  return {
    ...baseShopifyPlugin,
    ...extendedShopifyPlugin,
  }
}

export default buildShopifyPlugin
